import { lazy } from 'react';

const CustomWorkshopsMoveToBackup = lazy(() => import('./CustomWorkshopsMoveToBackup'));

export default CustomWorkshopsMoveToBackup;
